import React, { useState, useEffect } from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Spinner } from 'react-bootstrap'
import { Empty, Switch, message } from 'antd'

import { deleteServiceDeliveredDocument, storeServiceDeliveredDocument } from '../services'
import { getFormatTypes } from '../../FormatTypes/services'
import { handleError } from '../../../helpers'

export default function ToggleServiceDeliveredDocumentsModal({ 
	visible, onClose, reload, service, serviceDeliveredDocuments 
}) {
	const [options, setOptions] = useState(null)
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		!options && service && getFormatTypes({
			'filter[format_type]':'report_format',
			'filter[format_id]': service.service_format.report_format_id,
			'filter[setting_type]': 'delivered_document_type',
			include: 'setting'
		})
			.then(res => setOptions(res.data.data))
			.catch(handleError)
	}, [ options, service ])

	const handleStore = id => {
		setLoading(true)
		storeServiceDeliveredDocument({
			service_id: service.id,
			delivered_document_type_id: id
		})
			.then(res => {
				message.success(res.data.message)
				reload()
				setLoading(false)
			})
			.catch(error => handleError(error, setLoading))
	}

	const handleDelete = id => {
		setLoading(true)
		let serviceDeliveredDocument = serviceDeliveredDocuments.filter(s => s.delivered_document_type.id === id)[0]
		deleteServiceDeliveredDocument(serviceDeliveredDocument.id)
			.then(res => {
				message.success(res.data.message)
				reload()
				setLoading(false)
			})
			.catch(handleError, setLoading)
	}

	const isChecked = id => {
		let opt = serviceDeliveredDocuments.filter(s => s.delivered_document_type.id === id)
		return (opt.length > 0) ? true : false
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Documentos Entregados</ModalHeader>
				<ModalBody>
					{ options ? (
						<React.Fragment>
							{ options.length > 0 ? (
								<React.Fragment>
									{ options.map(opt => (
										<div key={opt.setting.id} className='mb-10'>
											<Switch
												loading={loading}
												checked={isChecked(opt.setting.id)}
												onChange={val => val ? (
													handleStore(opt.setting.id) 
												) : (
													handleDelete(opt.setting.id)
												)}
											/>
											<span className='ml-5'>{opt.setting.name}</span>
										</div>
									)) }
								</React.Fragment>
							) : <Empty description="No existen opciones para este formato" /> }
						</React.Fragment>
					) : <Spinner animation="border" size="sm" /> }
				</ModalBody>
		</Modal>
	)
}